import { NgModule, Injectable, Injector, defineInjectable, inject, INJECTOR } from '@angular/core';
import { CONFIG_MANAGER_SERVICE_CONFIGURATION, ConfigManagerModule, ConfigManagerService } from '@xpo-ltl/config-manager';
import { CommonModule } from '@angular/common';
import { Subject, of, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { UUID } from 'angular2-uuid';
import { tap, switchMap, map, catchError, take, finalize } from 'rxjs/operators';
import { get } from 'lodash';
import { FileContents } from '@xpo-ltl/sdk-common';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common/http';
import * as ɵngcc2 from '@xpo-ltl/config-manager';
const ɵ0 = { configFileUrl: './assets/config.json' };
class DataApiModule {
}
DataApiModule.ɵfac = function DataApiModule_Factory(t) { return new (t || DataApiModule)(); };
DataApiModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: DataApiModule });
DataApiModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        { provide: CONFIG_MANAGER_SERVICE_CONFIGURATION, useValue: ɵ0 },
    ], imports: [[
            CommonModule,
            ConfigManagerModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DataApiModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    ConfigManagerModule
                ],
                providers: [
                    { provide: CONFIG_MANAGER_SERVICE_CONFIGURATION, useValue: ɵ0 },
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DataApiModule, { imports: function () { return [CommonModule,
        ConfigManagerModule]; } }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {number} */
const NotificationTypeEnum = {
    ShowOverlay: 0,
    HideOverlay: 1,
    ShowSnackbar: 2,
};
NotificationTypeEnum[NotificationTypeEnum.ShowOverlay] = "ShowOverlay";
NotificationTypeEnum[NotificationTypeEnum.HideOverlay] = "HideOverlay";
NotificationTypeEnum[NotificationTypeEnum.ShowSnackbar] = "ShowSnackbar";

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class NotificationMessage {
    /**
     * @param {?} type
     * @param {?} text
     * @param {?=} snackbarConfig
     */
    constructor(type, text, snackbarConfig) {
        this.snackbarConfig = null;
        this.status = 'success';
        this.type = type;
        this.text = text;
        this.snackbarConfig = snackbarConfig;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class SnackbarConfig {
    constructor() {
        this.actionHandler = null;
        this.durationInMillis = 3000;
        this.status = 'success';
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class NotificationService {
    constructor() {
        this.subject = new Subject();
        this.showHideCountTracker = 0;
        this.showOverlay = false;
        this.referenceCount = 0;
        this.message = 'Loading...';
    }
    /**
     * @return {?}
     */
    getSubscriber() {
        return this.subject.asObservable();
    }
    /**
     * Sets the message that will be displayed, by default 'Loading...' will be used
     * @param {?} message
     * @return {?}
     */
    setOverlayMessage(message) {
        this.message = message;
    }
    /**
     * Shows the loading overlay
     * @param {?=} message
     * @return {?}
     */
    showOverlayMessage(message = 'Loading...') {
        this.referenceCount++;
        this.message = message;
        this.sendMessageToSubscribers(new NotificationMessage(NotificationTypeEnum.ShowOverlay, this.message, null));
        this.showOverlay = true;
    }
    /**
     * Hides the loading overlay
     * @return {?}
     */
    hideOverlayMessage() {
        this.referenceCount--;
        if (this.referenceCount <= 0) {
            this.referenceCount = 0;
            this.sendMessageToSubscribers(new NotificationMessage(NotificationTypeEnum.HideOverlay, null, null));
            this.message = '';
        }
    }
    /**
     * Forces hiding of the overlay
     * @return {?}
     */
    clearOverlayMessage() {
        this.referenceCount = 0;
        this.hideOverlayMessage();
    }
    /**
     * @param {?} message
     * @param {?=} snackbarConfig
     * @return {?}
     */
    showSnackBarMessage(message, snackbarConfig = new SnackbarConfig()) {
        this.sendMessageToSubscribers(new NotificationMessage(NotificationTypeEnum.ShowSnackbar, message, snackbarConfig));
    }
    /**
     * @param {?} message
     * @return {?}
     */
    sendMessageToSubscribers(message) {
        this.subject.next(message);
    }
    /**
     * @return {?}
     */
    clearSubscriberMessage() {
        this.subject.next();
    }
}
NotificationService.ɵfac = function NotificationService_Factory(t) { return new (t || NotificationService)(); };
NotificationService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: NotificationService, factory: NotificationService.ɵfac, providedIn: 'root' });
/** @nocollapse */
NotificationService.ctorParameters = () => [];
/** @nocollapse */ NotificationService.ngInjectableDef = defineInjectable({ factory: function NotificationService_Factory() { return new NotificationService(); }, token: NotificationService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NotificationService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return []; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DataApiService {
    /**
     * @param {?} http
     * @param {?} notificationService
     * @param {?} configManager
     */
    constructor(http, notificationService, configManager) {
        this.http = http;
        this.notificationService = notificationService;
        this.configManager = configManager;
        this.correlationId = '';
        this.correlationId = UUID.UUID();
    }
    /**
     * Generates a new correlation ID to be used.
     * @return {?}
     */
    startNewCorrelationSession() {
        this.correlationId = UUID.UUID();
    }
    /**
     * @return {?}
     */
    getCorrelationId() {
        return this.correlationId;
    }
    /**
     * @param {?} request
     * @return {?}
     */
    get(request) {
        const /** @type {?} */ requestUrl = this.generateFullyQualifiedUrl(request.serviceRootUri, request.queryParamString);
        return of(request.dataOptions).pipe(tap(this.handlePreRequestDuties.bind(this)), switchMap(() => this.http.get(requestUrl, /** @type {?} */ (request.httpOptions))), map(this.extractData), catchError(this.handleError(request.dataOptions)), take(1), finalize(this.handlePostRequestDuties(request.dataOptions)));
    }
    /**
     * @param {?} request
     * @return {?}
     */
    post(request) {
        const /** @type {?} */ requestUrl = this.generateFullyQualifiedUrl(request.serviceRootUri, request.queryParamString);
        return of(request.dataOptions).pipe(tap(this.handlePreRequestDuties.bind(this)), switchMap(() => this.http.post(requestUrl, request.body, /** @type {?} */ (request.httpOptions))), map(this.extractData), catchError(this.handleError(request.dataOptions)), take(1), finalize(this.handlePostRequestDuties(request.dataOptions)));
    }
    /**
     * @param {?} request
     * @return {?}
     */
    delete(request) {
        const /** @type {?} */ requestUrl = this.generateFullyQualifiedUrl(request.serviceRootUri, request.queryParamString);
        return of(request.dataOptions).pipe(tap(this.handlePreRequestDuties.bind(this)), switchMap(() => this.http.delete(requestUrl, /** @type {?} */ (request.httpOptions))), map(this.extractData), catchError(this.handleError(request.dataOptions)), take(1), finalize(this.handlePostRequestDuties(request.dataOptions)));
    }
    /**
     * @param {?} request
     * @return {?}
     */
    put(request) {
        const /** @type {?} */ requestUrl = this.generateFullyQualifiedUrl(request.serviceRootUri, request.queryParamString);
        return of(request.dataOptions).pipe(tap(this.handlePreRequestDuties.bind(this)), switchMap(() => this.http.put(requestUrl, request.body, /** @type {?} */ (request.httpOptions))), map(this.extractData), catchError(this.handleError(request.dataOptions)), take(1), finalize(this.handlePostRequestDuties(request.dataOptions)));
    }
    /**
     * @param {?=} url
     * @param {?=} queryParams
     * @return {?}
     */
    generateFullyQualifiedUrl(url = '', queryParams) {
        const /** @type {?} */ configuredApiUrl = /** @type {?} */ (this.configManager.getSetting('apiUrl'));
        const /** @type {?} */ conditionedApiRoot = `${configuredApiUrl}${configuredApiUrl.endsWith('/') ? '' : '/'}`;
        const /** @type {?} */ conditionedServiceUri = `${url.startsWith('/') ? url.substring(1) : url}`;
        const /** @type {?} */ conditionedQueryParams = (queryParams) ? `?${queryParams}` : '';
        return `${conditionedApiRoot}${conditionedServiceUri}${conditionedQueryParams}`;
    }
    /**
     * Unwraps the payload from the API envelope.
     * This will check the response code if provided and ensure it's within the 200-series (not all responses or response types will have it)
     * @param {?} response
     * @return {?}
     */
    extractData(response) {
        const /** @type {?} */ code = get(response, 'code');
        // tslint:disable-next-line
        if (!code || (code & 200) === 200 || get(response, 'access_token')) {
            if (!response) {
                return undefined;
            }
            else if (response.hasOwnProperty('data')) {
                return response.data;
            }
            else {
                return response;
            }
        }
        else {
            // TODO - I don't think this is correct.  The thrownError here is
            // not being caught since we are using a map() operator. This means that
            // we will get an observable of the error, not a thrown error.
            return throwError(response ? response.error : response);
        }
    }
    /**
     * @param {?} options
     * @return {?}
     */
    handleError(options) {
        const /** @type {?} */ _this = this; // prevents the need for a .bind(this) call
        return (error) => {
            if (options.toastOnError) {
                let /** @type {?} */ duration = 5000;
                if (options && options.snackBarConfig && options.snackBarConfig.durationInMillis) {
                    duration = options.snackBarConfig.durationInMillis;
                }
                if (error.status !== undefined && options.errorMessageMap != null && options.errorMessageMap.get(error.status)) {
                    _this.notificationService.showSnackBarMessage(options.errorMessageMap.get(error.status), { status: 'error', durationInMillis: duration });
                }
                else if (options.toastErrorMessage) {
                    _this.notificationService.showSnackBarMessage(options.toastErrorMessage, { status: 'error', durationInMillis: duration });
                }
                else if (error.error != null && error.error.error != null && error.error.error.message != null) {
                    _this.notificationService.showSnackBarMessage(`Error: ${error.error.error.message}`, { status: 'error', durationInMillis: duration });
                }
                else if (error.statusText != null) {
                    _this.notificationService.showSnackBarMessage(`Error: ${error.statusText}`, { status: 'error', durationInMillis: duration });
                }
                else {
                    _this.notificationService.showSnackBarMessage('System error. Please contact support.', { status: 'error', durationInMillis: duration });
                }
            }
            return throwError(error.error || error);
        };
    }
    /**
     * @param {?} options
     * @return {?}
     */
    handlePreRequestDuties(options) {
        if (options.startNewCorrelationId) {
            this.startNewCorrelationSession();
        }
        if (options.loadingOverlayEnabled) {
            this.notificationService.showOverlayMessage(options.loadingOverlayMessage);
        }
    }
    /**
     * @param {?} options
     * @return {?}
     */
    handlePostRequestDuties(options) {
        const /** @type {?} */ _this = this; // prevents the need for a .bind(this) call
        return () => {
            if (options.toastOnSuccess) {
                _this.notificationService.showSnackBarMessage(options.toastSuccessMessage, options.snackBarConfig);
            }
            if (options.loadingOverlayEnabled) {
                _this.notificationService.hideOverlayMessage();
            }
        };
    }
}
DataApiService.ɵfac = function DataApiService_Factory(t) { return new (t || DataApiService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(NotificationService), ɵngcc0.ɵɵinject(ɵngcc2.ConfigManagerService)); };
DataApiService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: DataApiService, factory: DataApiService.ɵfac, providedIn: 'root' });
/** @nocollapse */
DataApiService.ctorParameters = () => [
    { type: HttpClient },
    { type: NotificationService },
    { type: ConfigManagerService }
];
/** @nocollapse */ DataApiService.ngInjectableDef = defineInjectable({ factory: function DataApiService_Factory() { return new DataApiService(inject(HttpClient), inject(NotificationService), inject(ConfigManagerService)); }, token: DataApiService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DataApiService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: NotificationService }, { type: ɵngcc2.ConfigManagerService }]; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ApiRequest {
    /**
     * @param {?=} serviceRootUrl
     * @param {?=} queryParams
     * @param {?=} options
     * @param {?=} body
     * @param {?=} httpOptions
     */
    constructor(serviceRootUrl, queryParams, options, body, httpOptions) {
        this.serviceRootUri = serviceRootUrl;
        this.body = body;
        this.queryParams = queryParams || {};
        this.dataOptions = options || ApiRequest.defaultDataOptions;
        this.httpOptions = httpOptions;
    }
    /**
     * @return {?}
     */
    get queryParamString() {
        return this.objectToQueryString(this.queryParams);
    }
    /**
     * Converts an object to query/form string format
     * eg: {a:'1',b:'2'} -> a=1&b=2
     * @param {?=} data
     * @return {?}
     */
    objectToQueryString(data = {}) {
        let /** @type {?} */ queryString = '';
        const /** @type {?} */ buildQueryElement = (key, value) => {
            return value || value === 0 ? (key + '=' + encodeURI(value) + '&') : '';
        };
        Object.keys(data)
            .forEach(element => {
            if (data[element] instanceof Array) {
                (/** @type {?} */ ((data[element]))).forEach((arrayElement) => {
                    queryString += buildQueryElement(element, arrayElement);
                });
            }
            else if (data[element] instanceof Date) {
                queryString += buildQueryElement(element, (/** @type {?} */ (data[element])).getTime());
            }
            else {
                queryString += buildQueryElement(element, data[element]);
            }
        });
        return queryString.slice(0, -1); // remove trailing '&' (easier to do here as opposed to testing all values on creation);
    }
}
ApiRequest.defaultDataOptions = {
    loadingOverlayEnabled: true,
    loadingOverlayMessage: 'Loading...',
    toastOnSuccess: false,
    toastSuccessMessage: '',
    toastOnError: true,
    toastErrorMessage: '',
    errorMessageMap: undefined,
    startNewCorrelationId: false
};
ApiRequest.concealedCall = {
    loadingOverlayEnabled: false,
    toastOnSuccess: false,
    toastSuccessMessage: '',
    toastOnError: false,
    toastErrorMessage: '',
    errorMessageMap: undefined,
    startNewCorrelationId: false
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class CorrelationIdHttpInterceptor {
    /**
     * @param {?} injector
     */
    constructor(injector) {
        this.injector = injector;
        this.dataApi = undefined;
    }
    /**
     * @param {?} req
     * @param {?} next
     * @return {?}
     */
    intercept(req, next) {
        if (!this.dataApi) {
            this.dataApi = this.injector.get(DataApiService);
        }
        if (this.dataApi) {
            return next.handle(req.clone({ headers: req.headers.set('x-correlation-id', this.dataApi.getCorrelationId()) }));
        }
        return next.handle(req);
    }
}
CorrelationIdHttpInterceptor.ɵfac = function CorrelationIdHttpInterceptor_Factory(t) { return new (t || CorrelationIdHttpInterceptor)(ɵngcc0.ɵɵinject(ɵngcc0.Injector)); };
CorrelationIdHttpInterceptor.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: CorrelationIdHttpInterceptor, factory: CorrelationIdHttpInterceptor.ɵfac, providedIn: 'root' });
/** @nocollapse */
CorrelationIdHttpInterceptor.ctorParameters = () => [
    { type: Injector }
];
/** @nocollapse */ CorrelationIdHttpInterceptor.ngInjectableDef = defineInjectable({ factory: function CorrelationIdHttpInterceptor_Factory() { return new CorrelationIdHttpInterceptor(inject(INJECTOR)); }, token: CorrelationIdHttpInterceptor, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CorrelationIdHttpInterceptor, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc0.Injector }]; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @abstract
 */
class BaseService {
    constructor() {
        // this._converters.push( { type: ['string'], convert: (value) => value });
        this._converters = [];
    }
    /**
     * @param {?} value
     * @return {?}
     */
    hasConverter(value) {
        const /** @type {?} */ items = this._converters.find((item) => {
            return (item.type.some(x => x === (typeof value)));
        });
        return items ? items.convert : undefined;
    }
    /**
     * @param {?} test
     * @return {?}
     */
    isPrimitive(test) {
        return (test !== Object(test));
    }
    /**
     * @param {?} value
     * @param {?=} params
     * @return {?}
     */
    populateQueryParams(value, params) {
        if (!params) {
            params = {};
        }
        const /** @type {?} */ addValue = (item, key) => {
            if (!params[key]) {
                params[key] = [];
            }
            params[key].push(item);
        };
        Object.keys(value).forEach(key => {
            if (value[key] !== undefined) {
                if (this.isPrimitive(value[key])) {
                    addValue(value[key], key);
                }
                else if (value[key] instanceof Date) {
                    addValue(value[key].getTime(), key);
                }
                else if (Array.isArray(value[key])) {
                    value[key].forEach(item => {
                        this.populateQueryParams({ [key]: item }, params);
                    });
                }
                else {
                    const /** @type {?} */ converter = this.hasConverter(value[key]);
                    if (converter) {
                        addValue(converter(value[key]), key);
                    }
                    else {
                        this.populateQueryParams(value[key], params);
                    }
                }
            }
        });
        return params;
    }
    /**
     * Currently only supports simple objects.  That is objects the are singularly nested.  replacementValue must be
     * of type Object.
     * @param {?} basePath
     * @param {?} replacementValue
     * @return {?}
     */
    populatePathParams(basePath, replacementValue) {
        let /** @type {?} */ modifiedPath = basePath;
        if (!!replacementValue) {
            Object.keys(replacementValue).forEach(key => {
                if (replacementValue[key] !== undefined && replacementValue[key] !== null) {
                    if (this.isPrimitive(replacementValue[key])) {
                        modifiedPath = modifiedPath.replace(`{${key}}`, replacementValue[key]);
                    }
                    else if (replacementValue[key] instanceof Date) {
                        modifiedPath = modifiedPath.replace(`{${key}}`, replacementValue[key].getTime());
                    }
                    else if (Array.isArray(replacementValue[key])) {
                        modifiedPath = modifiedPath.replace(`{${key}}`, replacementValue[key].join(','));
                    }
                    else {
                        const /** @type {?} */ converter = this.hasConverter(replacementValue[key]);
                        if (converter) {
                            modifiedPath = modifiedPath.replace(`{${key}}`, converter(replacementValue[key]));
                        }
                        else {
                            modifiedPath = modifiedPath.replace(`{${key}}`, replacementValue[key]);
                        }
                    }
                }
            });
        }
        return modifiedPath;
    }
    /**
     * @param {?} url
     * @param {?} data
     * @param {?} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    generateApiRequest(url, data, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = new ApiRequest();
        apiRequest.dataOptions = dataOptions || ApiRequest.defaultDataOptions;
        if (httpOptions) {
            apiRequest.httpOptions = httpOptions;
        }
        if (data && data.body) {
            apiRequest.body = data.body;
        }
        else if (data && data.formData) {
            apiRequest.body = this.generateFormData(data.formData);
        }
        if (data && data.queryParams) {
            apiRequest.queryParams = this.populateQueryParams(data.queryParams);
        }
        if (data && data.pathParams) {
            apiRequest.serviceRootUri = this.populatePathParams(url, data.pathParams);
        }
        else {
            apiRequest.serviceRootUri = url;
        }
        return apiRequest;
    }
    /**
     * @param {?} uri
     * @return {?}
     */
    getUrl(uri) {
        let /** @type {?} */ url = this.getEndPoint();
        if (!url.endsWith('/') && !uri.startsWith('/')) {
            url += '/';
        }
        else if (url.endsWith('/') && uri.startsWith('/')) {
            url = url.substr(0, url.length - 1);
        }
        return `${url}${uri}`;
    }
    /**
     * @param {?} formDataRqst
     * @return {?}
     */
    generateFormData(formDataRqst) {
        return Object.keys(formDataRqst).reduce((formData, key) => {
            const /** @type {?} */ currInput = formDataRqst[key];
            if (currInput) {
                if (currInput instanceof Array && currInput.length > 0 && currInput[0] instanceof FileContents) {
                    (/** @type {?} */ (currInput)).forEach(file => {
                        const /** @type {?} */ blob = new Blob([file.contents.buffer]);
                        formData.append(key, blob, file.fileName);
                    });
                }
                else if (currInput instanceof FileContents) {
                    const /** @type {?} */ blob = new Blob([currInput.contents.buffer]);
                    formData.append(key, blob, currInput.fileName);
                }
                else {
                    formData.append(key, currInput);
                }
            }
            return formData;
        }, new FormData());
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ErrorMessageParser {
    /**
     * @param {?} err
     * @return {?}
     */
    static parseMessage(err) {
        let /** @type {?} */ reason = '';
        try {
            let /** @type {?} */ error = err['error'];
            if (error) {
                error = error['error'];
                if (error) {
                    if (error.moreInfo && error.moreInfo.some(item => item.errorCode)) {
                        const /** @type {?} */ moreInfoItem = error.moreInfo.filter(info => info.errorCode)[0];
                        reason = `${moreInfoItem.errorCode} ${moreInfoItem.message} ${moreInfoItem.location}`;
                    }
                    else if (error.errorCode && error.message) {
                        reason = `${error.errorCode} ${error.message}`;
                    }
                    else {
                        reason = 'Unknown error while validating PRO number';
                    }
                }
            }
        }
        catch (/** @type {?} */ err) {
            reason = 'Unable to parse error message';
        }
        return reason;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

export { DataApiService, ApiRequest, CorrelationIdHttpInterceptor, NotificationService, NotificationMessage, NotificationTypeEnum, SnackbarConfig, BaseService, ErrorMessageParser, DataApiModule };

